import React from 'react'
import type { GatsbySSR } from 'gatsby'
import { RecoilRoot } from 'recoil'

interface wrapperProps {
  element: any
  props: any
}

export const wrapRootElement = ({ element, props }: wrapperProps): any => {
  return <RecoilRoot {...props}>{element}</RecoilRoot>
}

export const onRenderBody: GatsbySSR['onRenderBody'] = ({
  setHtmlAttributes,
  setHeadComponents,
}) => {
  setHtmlAttributes({ lang: 'en' })

  const strapiHost = process.env.GATSBY_STRAPI_API_URL
  let strapiOrigin: string | null = null

  if (strapiHost) {
    try {
      strapiOrigin = new URL(strapiHost).origin
    } catch (_error) {
      strapiOrigin = null
    }
  }
  const preconnectLinks = [
    <link
      key="fonts-googleapis"
      rel="preconnect"
      href="https://fonts.googleapis.com"
    />,
    <link
      key="fonts-gstatic"
      rel="preconnect"
      href="https://fonts.gstatic.com"
      crossOrigin="anonymous"
    />,
    <link
      key="use-typekit"
      rel="preconnect"
      href="https://use.typekit.net"
      crossOrigin="anonymous"
    />,
  ]

  if (strapiOrigin) {
    preconnectLinks.push(
      <link
        key="strapi-origin"
        rel="preconnect"
        href={strapiOrigin}
        crossOrigin="anonymous"
      />,
    )
  }

  // Global Organization schema — appears on every page
  const organizationSchema = `{
    "@context": "https://schema.org",
    "@type": "Museum",
    "@id": "https://www.biharmuseum.org/#museum",
    "name": "Bihar Museum",
    "url": "https://www.biharmuseum.org",
    "logo": "https://www.biharmuseum.org/icons/icon-512x512.png",
    "image": "https://www.biharmuseum.org/static/e67e056a1d9a4fdc5a9cb08642fe09e9/32d68/building_8d4b07c592.webp",
    "description": "Bihar Museum is a world-class museum in Patna dedicated to the history, art, and culture of Bihar, home to the Didarganj Yakshi and Gupta dynasty artifacts.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bihar Museum, Jawaharlal Nehru Marg",
      "addressLocality": "Patna",
      "addressRegion": "Bihar",
      "postalCode": "800001",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "25.6126",
      "longitude": "85.1527"
    },
    "telephone": "+91-612-2235300",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
        "opens": "10:30",
        "closes": "17:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Monday",
        "opens": "00:00",
        "closes": "00:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/biharmuseum",
      "https://twitter.com/BiharMuseum",
      "https://www.instagram.com/biharmuseumofficial"
    ]
  }`

  setHeadComponents([
    ...preconnectLinks,
    <script
      key="organization-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: organizationSchema }}
    />,
  ])
}
